<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Solicita créditos promocionales</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  @if (!isHybrid) {
    <div class="promo-mobile-only">
      <p class="promo-mobile-only__message">{{ 'promotional_credits.promo_only_mobile' | translate }}</p>

      <div class="promo-mobile-only__stores">
        <a
          href="https://play.google.com/store/apps/details?id=com.okcargo.drivers"
          target="_blank"
          rel="noopener"
        >
          <img
            src="/assets/img/google-play.png.webp"
            alt="Descárgala en Google Play"
          />
        </a>
        <a
          href="https://apps.apple.com/es/app/okcargo/id6444137785"
          target="_blank"
          rel="noopener"
        >
          <img
            src="/assets/img/app-store.png.webp"
            alt="Descárgala en el App Store"
          />
        </a>
      </div>
    </div>
  }

  <div class="promo-info">
    <h2>¡Tus primeros DeCA, gratis!</h2>
    <p>
      Prepárate para la normativa obligatoria y
      <strong>prueba gratis la emisión de Documentos Electrónicos de Control Administrativo (DeCA)</strong> en OkCargo.
    </p>
    <ul>
      <li>
        <strong>Emite hasta 25 documentos (como transportista efectivo o cargador contractual).</strong>
      </li>
      <li>Generación de <strong>código QR para inspecciones</strong> y custodia del PDF durante 1 año.</li>
      <li><strong>Sin tarjeta ni compromisos,</strong> no requiere datos de pago.</li>
    </ul>

    <h3>Resumen de la condiciones de la promoción:</h3>
    <ul>
      <li><strong>Activación:</strong> Disponible en la app hasta el <strong>15 de octubre de 2026</strong>.</li>
      <li>
        <strong>Validez:</strong> Tienes <strong>30 días naturales</strong> para crear los documentos de control desde
        su activación.
      </li>
      <li><strong>Límite:</strong> 1 paquete de 25 créditos por empresa.</li>
    </ul>

    <p>
      <a
        href="https://documentodecontroldigital.com/eres-transportista-consigue-25-documentos-electronicos-de-control-deca-gratis/?utm_source=carriers-app&utm_medium=mobile&utm_campaign=promo-view"
        target="_blank"
      >
        Más información sobre nuestras soluciones para la gestión de Documentos electrónicos de Control Administrativo.
      </a>
    </p>
  </div>

  <div class="promo-legal-links">
    <p>
      <a
        href="https://documentodecontroldigital.com/legal/condiciones-particulares-de-la-promocion-tus-primeros-deca-gratis/?utm_source=carriers-app&utm_medium=mobile&utm_campaign=promo-view"
        target="_blank"
      >
        Condiciones particulares de la promoción «Tus primeros DeCA, gratis»
      </a>
    </p>
    <p>
      <a
        href="https://documentodecontroldigital.com/legal/condiciones-generales/?utm_source=carriers-app&utm_medium=mobile&utm_campaign=promo-view"
        target="_blank"
      >
        Condiciones de la contratación y del servicio de gestión de Documentos electrónicos de Control Administrativo
      </a>
    </p>
  </div>

  @if (isHybrid) {
    <form [formGroup]="form">
      <ion-item class="ion-margin-horizontal-negative">
        <ion-checkbox
          formControlName="acceptTerms"
          labelPlacement="end"
        >
          He leído y acepto las condiciones particulares de la promoción
        </ion-checkbox>
      </ion-item>

      @if (hasTermsError) {
        <div class="errors">Debes aceptar las condiciones de la promoción.</div>
      }

      @if (submitError(); as error) {
        <div class="errors">{{ error }}</div>
      }
    </form>
  }
</ion-content>

@if (isHybrid) {
  <ion-footer>
    <ion-toolbar>
      <ion-grid class="ion-padding-vertical-0">
        <ion-row>
          <ion-col>
            <ion-button
              (click)="submit()"
              color="primary"
              expand="block"
              fill="solid"
              size="large"
            >
              Enviar
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-toolbar>
  </ion-footer>
}
